<template>
  <client-only>
    <model-viewer
      ref="modelViewer"
      camera-controls
      touch-action="pan-y"
      :src="document.src"
      class="w-100 h-100"
      shadow-intensity="1"
      environment-image="neutral"
      exposure="1"
      @load="onLoad"
      @error="onError"
    >
      <v-container v-if="!isLoaded" class="fill-height">
        <v-row class="align-center justify-center">
          <v-col class="text-center">
            <v-progress-circular color="primary" indeterminate :size="60" :width="6" />
          </v-col>
        </v-row>
      </v-container>
      <div v-if="hasError" class="w-100 h-100 d-flex align-center justify-center pa-4">
        <v-card variant="tonal" max-width="420" class="w-100 text-center">
          <v-card-text class="py-10 d-flex flex-column align-center" style="gap: 12px">
            <img v-if="getFileIconSrc(document.meta)" :src="getFileIconSrc(document.meta)" style="max-height: 64px" />
            <div class="text-headline-large text-uppercase">{{ document.meta.extension }}</div>
            <div class="text-body-large text-medium-emphasis">{{ document.meta.description }}</div>

            <div class="d-flex" style="gap: 8px">
              <v-btn prepend-icon="download" @click="downloadFile(document.meta._id, document.meta.description, document.meta.extension)">
                {{ $t("download") }}
              </v-btn>
            </div>
          </v-card-text>
          <v-alert color="error" variant="tonal">{{ $t("failedToLoadModel") }}</v-alert>
        </v-card>
      </div>
    </model-viewer>
  </client-only>
</template>

<script setup lang="ts">
// the model-viewer is client-only so make sure it is only loaded client side
import type { ModelViewerElement } from "@google/model-viewer"

const { getFileIconSrc } = useFileExtensions()
const $i18n = useI18n()
const fileStore = useFileStore()
const mainStore = useMainStore()
const downloadFile = useDownloadFile(mainStore.notify, $i18n, fileStore)

defineProps<{
  document: {
    src?: string
    thumbnailSrc?: string
    meta: FileData
  }
}>()

onMounted(async () => {
  await import("@google/model-viewer")
})

const isLoaded = ref(false)
const hasError = ref(false)

const onLoad = () => {
  isLoaded.value = true
}

const onError = () => {
  isLoaded.value = true
  hasError.value = true
}

const modelViewer = useTemplateRef<ModelViewerElement>("modelViewer")
</script>
